import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { ICategoryProduct, IPaginatedResponse } from 'pages/supplier-intelligence/utils/types';
import type { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/supplier-intelligence/categories/products';

type TData = IPaginatedResponse<ICategoryProduct>;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, { path: string; page: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetSiCategoryProductsApi(categoryPath: string[], page: number, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();
  const path = categoryPath.join('>');

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint, { params: { path, page } });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useQueryWrapper([endpoint, { path, page }], queryFn, {
    enabled: isLoggedIn && categoryPath.length > 0,
    ...options,
  });
}
